import React, { useState } from 'react';
import ExclamationCircle from 'icons/indexed-icons/ExclamationCircle';
import X from 'icons/indexed-icons/X';
import { Button } from 'components/Button';
import ShoppingCart from 'icons/indexed-icons/ShoppingCart';
import { useTranslation } from 'react-i18next';
import Exclamation from 'icons/indexed-icons/Exclamation';
import {
  CardContainer,
  TopContainer,
  TitleContainer,
  Title,
  Circle,
  SubtitleContainer,
  TimeContainer,
  LeftTimeSection,
  AlertStatus,
  AlertDescription
} from './index.elements';
import theme from 'themes';
import { AlertTriggers, CartPriceChangeAlert } from 'types/machine-health/alerts';
import { useHeader } from 'components/Header/HeaderContext';
import { JBTRoutes } from 'constants/routes';
import { useHistory } from 'react-router-dom';
import { getNotificationId } from './utils';

interface NotificationCardProps {
  data?: AlertTriggers;
  isAlternative?: boolean;
  updateNotificationStatus?: (id: string) => void;
  deleteNotification?: (id?: string) => void;
  showNotificationDetails?: (type: string, customData?: CartPriceChangeAlert) => void;
}
const NotificationCard = ({
  data,
  isAlternative,
  updateNotificationStatus,
  deleteNotification,
  showNotificationDetails
}: NotificationCardProps): JSX.Element => {
 
  const [notificationData, setNotificationData] = useState<AlertTriggers | undefined>();
  const { dispatch } = useHeader();


  const { t } = useTranslation(['fpns']);
  const history = useHistory();

  React.useEffect(() => {
    if (data) {
      setNotificationData({ ...data });
    }
  }, [data]);

  const getUserActionText = (alertType: string | undefined) => {
    if (!alertType) return '';
    switch (alertType) {
      case 'PRICE_CHANGE':
        return t('open_saved_product_list');
      case 'ORDER_PLACED':
        return 'View Order Details';
      case 'QUOTE_SUBMITTED':
        return 'Open Quotes';
      case 'QUOTE_REQUEST':
        return 'Open Quotes';
      case 'ORDER_REQUEST':
        return 'Open Orders';
      case 'QUOTE_PRICED':
        return t('open_saved_product_list');
      default:
        return t('view_details');
    }
  };

  const triggerUserAction = (alertType: string | undefined, notification?: AlertTriggers) => {
    if (!alertType) return;
    const notificationId = getNotificationId(notification);

    switch (alertType) {
      case 'PRICE_CHANGE':
        dispatch({ type: 'showSavedProduct' });
        break;
      case 'ORDER_PLACED':
        showNotificationDetails &&
          showNotificationDetails(alertType, notification?.customData as CartPriceChangeAlert);
        if (notificationId) {
          updateNotificationStatus && updateNotificationStatus(notificationId);
        }
        break;
      case 'QUOTE_SUBMITTED':
        history.push({
          pathname: JBTRoutes.partsOrders,
          search: `?tab=1`
        });
        break;
      case 'QUOTE_REQUEST':
        history.push({
          pathname: JBTRoutes.partsOrders,
          search: `?tab=1`
        });
        break;
      default:
        console.log('Viewing Details...');
    }
  };
  return (
    <CardContainer>
      <TopContainer>
        <TitleContainer>
          <span style={{ width: '1.4rem', display: 'flex', justifyContent: 'center' }}>
           {notificationData?.status !== 'READ' && (
              <Circle />
            )}
          </span>
          <Title>
           <span>{notificationData?.alertName}</span>
          </Title>
          <Button
           className="delete-notification"
           width="3rem"
           variant="inline-link"
           onClick={() => {
             const notificationId = getNotificationId(notificationData);
             if (notificationId) {
               deleteNotification && deleteNotification(notificationId);
             }
           }}
          >
           <X color={theme.colors.darkGrey} />
          </Button>
        </TitleContainer>
        <SubtitleContainer>
          {notificationData?.priority === 'HIGH' && (
            <ExclamationCircle color={theme.colors.darkRed3} />
          )}
          {notificationData?.priority === 'MEDIUM' && <Exclamation color={theme.colors.warning} />}
          {isAlternative && <ShoppingCart color={theme.colors.primaryBlue5} />}
          <AlertStatus status={notificationData?.priority}>
            {' '}
            {notificationData?.priority === 'HIGH'
              ? 'High Alert'
              : notificationData?.priority === 'MEDIUM'
              ? 'Medium Alert'
              : ''}
          </AlertStatus>
          {isAlternative && (
            <span className="machine-id">
              {isAlternative ? t('order_id') : t('machine_id')}: {'data.machineId'}
            </span>
          )}
        </SubtitleContainer>
      </TopContainer>

      <AlertDescription>
        <div className="alert-description">{notificationData?.alertMessage}</div>
       
      </AlertDescription>

      <TimeContainer>
        <LeftTimeSection className={notificationData?.status === 'READ' ? '' : 'open-alert'}>
          <span>{notificationData?.start}</span>
          <Button
            width="3rem"
            variant="inline-link"
            onClick={() => {
              triggerUserAction(notificationData?.alertType, notificationData);
            }}
          >
            {getUserActionText(notificationData?.alertType)}
          </Button>
        </LeftTimeSection>
        
      </TimeContainer>
    </CardContainer>
  );
};

export default NotificationCard;
